import { useTranslation } from "react-i18next";
import { useContext, useState, useCallback } from "react";
import { AuthContext } from "../../authContext";
import AlertsCustom from "../../components/Alerts";
import "./OneDriveFilesList.css";

function OneDriveFilesList({ files = [], folders = [], onClose, onOpenOptions, assistantId, onFolderDeleted, setFiles, setFolders, canCreateFolder = true, onAddFile }) {
  const { t } = useTranslation("assistantConfiguration");
  const { t: tChat } = useTranslation('chat');
  const { accessToken } = useContext(AuthContext);
  const { t: tSelfAssist } = useTranslation('assistantConfiguration');
  const [alert, setAlert] = useState({ title: '', type: '', message: '', open: false });
  const [isReloading, setIsReloading] = useState(false);

  const getTempoRelativo = (dataString) => {
    if (!dataString) return tChat('today');

    const itemDate = new Date(dataString.replace(' ', 'T'));
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const startOfItemDate = new Date(itemDate.getFullYear(), itemDate.getMonth(), itemDate.getDate());
    const diffTime = startOfToday.getTime() - startOfItemDate.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 3600 * 24));

    if (diffDays <= 0) {
      return tChat('today');
    } else if (diffDays === 1) {
      return tChat('day_1');
    } else if (diffDays === 2) {
      return tChat('day_2');
    } else if (diffDays === 3) {
      return tChat('day_3');
    } else if (diffDays === 4) {
      return tChat('day_4');
    } else if (diffDays === 5) {
      return tChat('day_5');
    } else if (diffDays === 6) {
      return tChat('day_6');
    } else if (diffDays === 7) {
      return tChat('day_7');
    } else {
      return tChat('days_older');
    }
  };

  const sortByDate = (items) => {
    return [...items].sort((a, b) => {
      const dateA = a.synced_at ? new Date(a.synced_at.replace(' ', 'T')).getTime() : 0;
      const dateB = b.synced_at ? new Date(b.synced_at.replace(' ', 'T')).getTime() : 0;
      return dateB - dateA;
    });
  };

  const handleReloadOneDriveFolder = useCallback(async () => {
        console.log('handleReloadOneDriveFolder chamado', { assistantId });
        if (!assistantId) {
            setAlert({
                title: 'Erro',
                type: 'error',
                message: tSelfAssist('assistant_id_not_found'),
                open: true,
            });
            return;
        }
        setIsReloading(true);

        try {
            const reloadUrl = process.env.REACT_APP_AZURE_FUNCTION_SELFASSISTANT_FOLDER_RELOAD_URL_LOCAL;
            const response = await fetch(reloadUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify({ assistant_id: assistantId }),
            });

            console.log('Response status:', response.status);
            if (!response.ok) {
                throw new Error(`Erro ${response.status}`);
            }

            // setAlert({
            //     title: '',
            //     type: 'success',
            //     message: tSelfAssist('onedrive_reload_success') || 'Pasta recarregada com sucesso',
            //     open: true,
            // });
        } catch (err) {
            console.error('Erro ao recarregar pasta OneDrive:', err);
            setAlert({
                title: 'Erro',
                type: 'error',
                message: tSelfAssist('onedrive_reload_error') || 'Erro ao recarregar pasta',
                open: true,
            });
        } finally {
            setIsReloading(false);
        }
    }, [assistantId, accessToken, tSelfAssist]);

  const handleDeleteFolder = (folder) => {
    setFolders(prevFolders => {
      const newFolders = prevFolders.filter(f => f.folder_id !== folder.folder_id);
      if (newFolders.length === 0 && files.length === 0) {
        onClose();
      }
      return newFolders;
    });

    fetch(`${process.env.REACT_APP_API_URL}/delete_onedrive_folder_selfassistant`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        assistant_id: assistantId,
        drive_id: folder.drive_id,
        user_email: folder.user_email,
        folder_id: folder.folder_id
      })
    }).then(response => {
      if (!response.ok) {
        response.json().then(error => console.error('Erro ao deletar pasta:', error));
      } else {
        onFolderDeleted?.(folder);
      }
    }).catch(error => console.error('Erro ao deletar pasta:', error));
  };

  const handleDeleteFile = (file) => {
    setFiles(prevFiles => {
      const newFiles = prevFiles.filter(f => !(f.id === file.id && f.filename === file.filename));
      if (newFiles.length === 0 && folders.length === 0) {
        onClose();
      }
      return newFiles;
    });

    fetch(`${process.env.REACT_APP_API_URL}/delete_async_documents_selfassistant`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
      body: JSON.stringify({
        docs: {
          id: file.id || []
        },
        assistant_id: assistantId
      })
    }).then(response => {
      if (!response.ok) {
        response.json().then(error => console.error('Erro ao deletar arquivo:', error));
      } else {
        onFolderDeleted?.(file);
      }
    }).catch(error => console.error('Erro ao deletar arquivo:', error));
  };

  return (
    <div className="onedrive-files-list-container">
      {alert.open && (
        <AlertsCustom
          type={alert.type}
          title={alert.title}
          message={alert.message}
          onClose={() => setAlert(prev => ({ ...prev, open: false }))}
        />
      )}
      <div className={`onedrive-files-list-wrapper ${!canCreateFolder ? 'without-reload' : ''}`}>
        <button
          className="btn-onedrive-self"
          onClick={canCreateFolder ? onOpenOptions : onAddFile}
        >
          <img
            src="/imagens/onedrive.svg"
            alt="onedrive-icon"
            className="img-onedrive-self"
          />
          {t("oneDriveButton")}
        </button>
        {canCreateFolder && (
          <button
            className="onedrive-files-list-reload"
            onClick={handleReloadOneDriveFolder}
            disabled={isReloading}
            style={{ opacity: isReloading ? 0.6 : 1, cursor: isReloading ? 'not-allowed' : 'pointer' }}
          >
            <img
              src="/imagens/restore-icon.svg"
              alt="Recarregar"
              className={isReloading ? 'reload-folder-icon--spinning' : ''}
            />
          </button>
        )}
      </div>

      <div className="onedrive-items-list">
        {/* Renderizando as Pastas */}
        {folders && folders.length > 0 && (
          sortByDate(folders).map((folder, index) => {
            return (
              <div className="onedrive-item" key={`folder-${index}`}>
                <div className="onedrive-item-info">
                  <div className="onedrive-item-icon">
                    <img src="/imagens/add-folder.svg" alt="Ícone de pasta" />
                  </div>
                  <span className="onedrive-item-name" title={folder.folder_name}>{folder.folder_name}</span>
                </div>
                <div className="onedrive-item-wrapper">
                  <span className="onedrive-item-date">{getTempoRelativo(folder.synced_at)}</span>
                  <img
                    src="/imagens/x-circle.svg"
                    alt="Delete Icon"
                    className="onedrive-item-delete"
                    onClick={() => handleDeleteFolder(folder)}
                  />
                </div>
              </div>
            );
          })
        )}
        {/* Renderizando os Arquivos */}
        {files && files.length > 0 && (
          sortByDate(files).map((file, index) => {
            return (
              <div className="onedrive-item" key={`file-${index}`}>
                <div className="onedrive-item-info">
                  <div className="onedrive-item-icon">
                    <img src="/imagens/create-classifier.svg" alt="Ícone de arquivo" />
                  </div>
                  <span className="onedrive-item-name" title={file.filename}>{file.filename}</span>
                </div>
                <div className="onedrive-item-wrapper">
                  <span className="onedrive-item-date">{getTempoRelativo(file.synced_at)}</span>
                  <img
                    src="/imagens/x-circle.svg"
                    alt="Delete Icon"
                    className="onedrive-item-delete"
                    onClick={() => handleDeleteFile(file)}
                  />
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

export default OneDriveFilesList;
